/**
 * DatePicker: a thin wrapper over react-datepicker (spec § Third-party widgets). The
 * library keeps its own popup, keyboard and month navigation; this hands it the STARS
 * <Input> and the `stars-datepicker` class that src/styles/vendor.css themes with
 * --stars-* variables. All react-datepicker props pass through.
 */
import React, { forwardRef } from "react";
import ReactDatePicker from "react-datepicker";
import { Input } from "./Input";
import { cn } from "./cn";

export const DatePicker = forwardRef(function DatePicker(
  {
    className,
    calendarClassName,
    popperClassName,
    wrapperClassName,
    inline,
    customInput,
    ...props
  },
  ref,
) {
  return (
    <ReactDatePicker
      ref={ref}
      inline={inline}
      customInput={
        inline ? undefined : customInput || <Input className={className} />
      }
      calendarClassName={cn("stars-datepicker", calendarClassName)}
      popperClassName={cn("stars-datepicker-popper", popperClassName)}
      wrapperClassName={cn("tw-block", wrapperClassName)}
      showPopperArrow={false}
      {...props}
    />
  );
});
